/** Auf false setzen, um die Tipps-Navigation und -Route wieder zu aktivieren. */
export const hideTipsNav = true;

/** Auf true setzen, um den Menüpunkt „Partnerfriedhöfe“ und die zugehörige Route auszublenden. */
export const hidePartnerfriedhoefeNav = true;
